module.exports = __webpack_public_path__ + "img/selected-quick-link.0be5c9c6.svg";